module.exports = __webpack_public_path__ + "static/media/ShutterbugPhoto_Booth_Logo.d893118a.jpg";